// extracted by mini-css-extract-plugin
export default {"footerContainer":"UserTypeAssignmentPopup_footerContainer__D-vRW"};